"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

// todo 样式文件直接引用 selfNavigation
function SelfNavigation(props) {
  var _a = props || {},
      onCallBack = _a.onCallBack,
      _b = _a.configuration,
      configuration = _b === void 0 ? [] : _b;

  var _c = (0, _react.useState)(false),
      expendNode = _c[0],
      setExpendNode = _c[1];

  var _d = (0, _react.useState)(configuration.length ? configuration[0] : {}),
      currentTxt = _d[0],
      setCurrentTxt = _d[1];

  var li_a = (0, _react.useRef)(null);

  var switchPane = function switchPane() {
    if (!li_a.current || !li_a.current.style) return;
    var _height = 0;

    if (!expendNode) {
      setExpendNode(true);
      _height = configuration.length ? configuration.length * 40 + "px" : 0;
    } else {
      setExpendNode(false);
      _height = '0';
    }

    if (typeof _height === 'string') {
      li_a.current.style.height = _height;
    }
  };

  var switchChild = function switchChild(label, index) {
    // @ts-ignore
    li_a.current.style.height = 0;

    if (label) {
      setCurrentTxt(__assign(__assign({}, currentTxt || {}), {
        label: label
      }));
      setExpendNode(!expendNode);
    } else {
      setCurrentTxt(__assign({}, currentTxt || {}));
    }

    onCallBack(index);
  };

  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(function (status) {
      if (!status) {
        switchChild('', 0);
      }
    }, 1);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'im-self-navigation-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: switchPane,
    className: (0, _classnames["default"])('self-navigation-container__nav hover-box-shadow', {
      ' hover-box-shadow--ex': expendNode
    })
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: 'self-navigation-container__nav__h3'
  }, currentTxt ? currentTxt.label || '' : ''), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('self-navigation-container__nav__span', {
      'self-navigation-container__nav__span--rotate': expendNode
    })
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "design-iconfont"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "rotate(-180 12.25 12.25)",
    d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
    fill: "currentColor"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'max-view'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: li_a,
    style: {
      height: '0',
      overflow: 'hidden',
      transition: ' all 0.3s ease'
    },
    className: (0, _classnames["default"])('self-navigation-container__node')
  }, configuration.map(function (item, index) {
    var _a = (item || {}).label,
        label = _a === void 0 ? '' : _a;
    return /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick() {
        switchChild(label, index);
      },
      key: index,
      className: 'self-navigation-container__nav self-navigation-container__nav--hover'
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      style: currentTxt && currentTxt.label === label ? {
        color: '#006eff'
      } : {},
      className: 'self-navigation-container__nav__h3 self-navigation-container__nav__h3--extend'
    }, label), currentTxt && currentTxt.label === label ? /*#__PURE__*/_react["default"].createElement(Svg, null) : null);
  }))));
}

var _default = SelfNavigation;
exports["default"] = _default;

function Svg() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "15",
    viewBox: "0 0 20 15",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07166 6.41437L0.780273 7.76038L6.90607 14.2694L19.902 1.41284L18.5437 0.0183105L6.81757 10.1192L2.07166 6.41437Z",
    fill: "#006EFF"
  }));
}